import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["list", "row", "template", "emptyState", "destroyField"]

  connect() {
    this.updateEmptyState()
  }

  add(event) {
    event.preventDefault()

    // Get the template content
    const template = this.templateTarget.innerHTML

    // Generate a unique ID for the new record
    const uniqueId = new Date().getTime()

    // Replace the placeholder with the unique ID
    const newRow = template.replace(/NEW_RECORD/g, uniqueId)

    // Add the new row to the list
    this.listTarget.insertAdjacentHTML("beforeend", newRow)

    // Update radio button names to ensure mutual exclusivity
    this.updateRadioNames()

    this.updateEmptyState()
  }

  remove(event) {
    event.preventDefault()

    const row = event.target.closest("[data-billing-options-target='row']")

    if (row) {
      // Find the destroy field within this row
      const destroyField = row.querySelector("[data-billing-options-target='destroyField']")

      if (destroyField) {
        // If this is a persisted record (has an ID), mark for destruction
        const idField = row.querySelector("input[type='hidden'][name*='[id]']")
        if (idField && idField.value) {
          destroyField.value = "1"
          row.style.display = "none"
        } else {
          // If it's a new record, just remove it
          row.remove()
        }
      } else {
        // Fallback: just remove the row
        row.remove()
      }
    }

    this.updateEmptyState()
  }

  updateEmptyState() {
    const visibleRows = this.rowTargets.filter(row => row.style.display !== "none")

    if (this.hasEmptyStateTarget) {
      if (visibleRows.length === 0) {
        this.emptyStateTarget.classList.remove("hidden")
      } else {
        this.emptyStateTarget.classList.add("hidden")
      }
    }
  }

  updateRadioNames() {
    // Ensure all default radio buttons share the same name for mutual exclusivity
    const radios = this.element.querySelectorAll("input[type='radio'][name*='is_default']")
    radios.forEach((radio, index) => {
      // Use a common name so they're mutually exclusive
      radio.name = `offered_service[default_billing_option]`
    })
  }
}
